import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_yoga_f_tai_chi_prices~1
		'activity-female-yoga': {
			paywall: {
				experiment: () =>
					import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_yoga_f_tai_chi_prices'),
			},
		},
	},
]

export default config
